module.exports = __webpack_public_path__ + "img/orderIco3.b7063078.png";